export class RequestOptionsArguments {
  headers?: { [key: string]: string };

  params?: { [key: string]: string };
}
